import { FC } from "react";
import { IconPropsType } from ".";

export const AngleRight: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? 8}
      height={props.size ?? 10}
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25312 5L0.666565 8.49812L2.20656 10L7.33313 5L2.20656 2.01946e-07L0.666566 1.50187L4.25312 5Z"
        fill={props.color}
      />
    </svg>
  );
};
